import React, { useEffect } from 'react';
import PageCarousel from '../components/PageCarousel';

function Program() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const scheduleData = [
    {
      day: 'July 22, 2026 (Day 1 – Tutorial Day)',
      events: [
        { time: '8:00 am – 12:00 pm', title: 'Registration', details: '', venue: 'RIEP Lobby' },
        { time: '9:00 am – 9:45 am', title: 'Inauguration', details: 'Inaugural Ceremony', venue: 'LT-17' },
        { time: '9:45 am – 10:15 am', title: 'High Tea Break', details: '', venue: '-' },
        { time: '10:15 am – 11:30 am', title: 'Keynote Talk', details: 'Prof. A.N. Rajagopalan, IITM', venue: 'LT-17' },
        { 
          time: '11:30 am – 1:30 pm', 
          title: 'Invited Tutorials (tea break 12:30-12:45 pm)', 
          details: '“Compositional Zero-shot Learning”\n- Prof. Dipti Prasad Mukherjee, ISI Kolkata and Dr. Aditya Pandey, CSIR Fourth Paradigm Institute, Bengaluru', 
          venue: 'LT-17' 
        },
        { 
          time: '11:30 am – 1:30 pm', 
          title: 'Invited Tutorials (tea break 12:30-12:45 pm)', 
          details: '“Reason with Numerals and Text - Unlock and Merge data from heterogeneous sources to derive insights”\n- Prof. Lipika Dey, Ashoka University', 
          venue: 'LT-16' 
        },
        { time: '1:30 pm – 2:30 pm', title: 'Lunch', details: '', venue: '-' },
        { time: '2:30 pm – 4:30 pm', title: 'Registration', details: '', venue: 'RIEP Lobby' },
        { 
          time: '2:30 pm – 4:30 pm', 
          title: 'Invited Tutorials (tea break 3:30-3:45 pm)', 
          details: '“From CNNs to Mamba: The Evolution of Vision AI from Classification to Generative and Agentic Intelligence”\n- Dr. Badri Narayan Patro, Microsoft Research', 
          venue: 'LT-17' 
        },
        { 
          time: '2:30 pm – 4:30 pm', 
          title: 'Invited Tutorials (tea break 3:30-3:45 pm)', 
          details: '“Continual Learning of Emerging Concepts and Domains in Computer Vision”\n- Prof. Soma Biswas, IISc Bangalore', 
          venue: 'LT-16' 
        },
        { time: '4:30 pm – 5:30 pm', title: 'Panel Discussion', details: '“Teaching Visual Computing in the Age of AI: What Should Humans Still Learn?”\nModerated by Prof. Santanu Chaudhury, IIT Delhi', venue: 'LT-17' },
        { time: '5:30 pm – 6:30 pm', title: 'IUPRAI Meeting', details: '', venue: 'LT-17' }
      ]
    },
    {
      day: 'July 23, 2026 (DAY 2)',
      events: [
        { time: '9:00 am – 11:00 am', title: 'Registration', details: '', venue: 'RIEP Lobby' },
        { time: '9:00 am – 10:15 am', title: 'Keynote Talk', details: '“Harnessing AI for Healthcare”\n- Prof. Sushmita Mitra, ISI Kolkata', venue: 'LT-17' },
        { time: '10:15 am – 10:30 am', title: 'Tea break', details: '', venue: '-' },
        { time: '10:30 am – 11:45 am', title: 'Keynote Talk', details: '“When Identity Meets AI: Towards Accurate, Explainable, and Contactless Palmprint Identification”\n- Prof. Ajay Kumar, Hong Kong PolyU', venue: 'LT-17' },
        { 
          time: '11:45 am – 1:15 pm', 
          title: 'Paper Presentations - Session 1', 
          details: 'Track 1\nPaper IDs: 12, 60, 66, 269, 271, 64', 
          venue: 'LT-16' 
        },
        { 
          time: '11:45 am – 1:15 pm', 
          title: 'Paper Presentations - Session 1', 
          details: 'Track 2\nPaper IDs: 36, 163, 194, 199, 259', 
          venue: 'LT-17' 
        },
        { 
          time: '11:45 am – 1:15 pm', 
          title: 'Paper Presentations - Session 1', 
          details: 'Track 3\nPaper IDs: 41, 73, 223, 232, 251, 288', 
          venue: 'LT-18' 
        },
        { 
          time: '11:45 am – 1:15 pm', 
          title: 'Paper Presentations - Session 1', 
          details: 'Track 4\nPaper IDs: 45, 55, 77, 94, 42', 
          venue: 'LT-19' 
        },
        { time: '1:15 pm – 2:15 pm', title: 'Lunch', details: '', venue: '-' },
        { time: '2:15 pm – 4:15 pm', title: 'Registration', details: '', venue: 'RIEP Lobby' },
        { time: '2:15 pm – 3:30 pm', title: 'Keynote Talk', details: '“Video Human Action Understanding”\n- Dr. Francois Bremond, INRIA', venue: 'LT-17' },
        { time: '3:30 pm – 3:45 pm', title: 'Tea break', details: '', venue: '-' },
        { 
          time: '3:45 pm – 5:15 pm', 
          title: 'Paper Presentations - Session 2', 
          details: 'Track 1\nPaper IDs: 107, 193, 275, 280, 265', 
          venue: 'LT-16' 
        },
        { 
          time: '3:45 pm – 5:15 pm', 
          title: 'Paper Presentations - Session 2', 
          details: 'Track 2\nPaper IDs: 115, 155, 161, 204, 257', 
          venue: 'LT-17' 
        },
        { 
          time: '3:45 pm – 5:15 pm', 
          title: 'Paper Presentations - Session 2', 
          details: 'Track 3\nPaper IDs: 63, 84, 110, 121, 201, 222', 
          venue: 'LT-18' 
        },
        { 
          time: '3:45 pm – 5:15 pm', 
          title: 'Paper Presentations - Session 2', 
          details: 'Track 4\nPaper IDs: 139, 202, 205, 240', 
          venue: 'LT-19' 
        },
        { 
          time: '3:45 pm – 5:15 pm', 
          title: 'Industry Session', 
          details: 'Industry demo - MATLAB', 
          venue: 'CMLBDA' 
        },
        { 
          time: '5:15 pm – 6:15 pm', 
          title: 'Panel Discussion', 
          details: '“From Accuracy to Accountability: Can AI be Trusted in High-Stakes Decision Making?”\nModerated by Prof. Anoop Namboodiri, IIIT Hyderabad', 
          venue: 'LT-17' 
        },
        { time: '6:30 pm', title: 'Cultural Program', details: '', venue: 'LT-1' },
        { time: '8:00 pm', title: 'Gala Dinner', details: '', venue: 'Mess-A' }
      ]
    },
    {
      day: 'July 24, 2026 (DAY 3)',
      events: [
        { time: '9:00 am – 11:00 am', title: 'Registration', details: '', venue: 'RIEP Lobby' },
        { time: '9:00 am – 10:15 am', title: 'Keynote Talk', details: 'Prof. Venkatesh Babu, IISc Bangalore', venue: 'LT-17' },
        { time: '10:15 am – 10:30 am', title: 'Tea Break', details: '', venue: '-' },
        { time: '10:30 am – 11:45 am', title: 'Keynote Talk', details: '“From Capability to Control: Engineering Trustworthy Generative AI”\nProf. Mayank Vatsa, IIT Jodhpur', venue: 'LT-17' },
        { 
          time: '11:45 am – 1:00 pm', 
          title: 'Challenges', 
          details: '“Automated Detection of Glacial Lakes from Multi-Temporal Satellite Imagery”\nDr. S. Vidhusha, Dr. K. B. Sundhara Kumar, Dr. K. Uthradevi (Shiv Nadar University Chennai)', 
          venue: 'LT-3' 
        },
        { 
          time: '11:45 am – 1:00 pm', 
          title: 'Challenges', 
          details: '“Persistent Scene Change Detection and Localization in Fixed-Camera Surveillance Videos (PSCDL 2026)”\nDr. Shikha Gupta, Shivam Nigam, Rizwan, Abhijith P Mahadevan (Vehant Technologies Private Limited)', 
          venue: 'LT-4' 
        },
        { 
          time: '11:45 am – 1:00 pm', 
          title: 'Challenges', 
          details: '“AutoAnn-Indic: Human-Effort Efficient Automated Annotation for Indic Manuscripts and Ram Charit Manas”\nDr. Indra Deep Mastan, Dr. Aprajita Khan, Mr. Satyendra Yadav (IIT (BHU) Varanasi), Dr. Anukriti Bansal (The LNMIIT Jaipur)', 
          venue: 'LT-5' 
        },
        
        { 
          time: '11:45 am – 1:00 pm', 
          title: 'Paper Presentations - Session 3', 
          details: 'Track 1\nPaper IDs: 79, 253, 260, 261', 
          venue: 'LT-16' 
        },
        { 
          time: '11:45 am – 1:00 pm', 
          title: 'Paper Presentations - Session 3', 
          details: 'Track 2\nPaper IDs: 263, 273, 277, 226, 228', 
          venue: 'LT-17' 
        },
        { 
          time: '11:45 am – 1:00 pm', 
          title: 'Paper Presentations - Session 3', 
          details: 'Track 3\n Paper IDs: 15, 21, 76, 184, 92, 117, 179, 270, 272', 
          venue: 'LT-18' 
        },
        
        { time: '1:00 pm – 2:00 pm', title: 'Lunch', details: '', venue: '-' },
        { 
          time: '2:00 pm – 3:00 pm', 
          title: 'Invited Talk', 
          details: '“Future of Spatial Computing”\nDr. Brojeshwar Bhowmick, TCS Research', 
          venue: 'LT-16' 
        },
        { 
          time: '2:00 pm – 3:00 pm', 
          title: 'Invited Talk', 
          details: 'Shri V. Manavala Ramanujam, ISRO', 
          venue: 'LT-17' 
        },
        { time: '3:00 pm – 3:15 pm', title: 'Tea break', details: '', venue: '-' },
        { 
          time: '3:15 pm – 4:30 pm', 
          title: 'Tutorials', 
          details: '“Medical Computing through Graph Processing: From Theory to Clinical-Grade AI Systems”\n- Dr. Saurabh J. Shigwan, Shiv Nadar University and Dr. Abhishek Tiwari, BIT Mesra', 
          venue: 'LT-16' 
        },
        { 
          time: '3:15 pm – 4:30 pm', 
          title: 'Tutorials', 
          details: '“Transformer Adaptation in Practice: Transfer Learning, Domain Adaptation, and Efficient Fine-Tuning”\n- Dr. Vinod K. Kurmi, IISER Bhopal and Dr. Rini Smita Thakur, IISER Bhopal', 
          venue: 'LT-17' 
        },
        { time: '4:30 pm – 5:00 pm', title: 'Valedictory Ceremony', details: '', venue: 'LT-17' }
      ]
    }
  ];

  return (
    <div className="page-container">
      <PageCarousel />
      <section className="section-padding py-5">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="section-title-header text-center mb-5">
                <h1 className="section-title fw-bold" style={{color: '#002147'}}>Conference Program Schedule</h1>
                <p className="text-muted">Full schedule for all three days listed below.</p>
              </div>

              <div className="row justify-content-center">
                <div className="col-lg-11 col-md-12">
                  
                  {scheduleData.map((daySchedule, dayIndex) => (
                    <div key={dayIndex} className="mb-5">
                      {/* Day Header */}
                      <h4 className="mb-3 p-3 text-white fw-bold" style={{backgroundColor: '#002147', borderRadius: '4px'}}>
                        {daySchedule.day}
                      </h4>
                      
                      {/* Simple Bootstrap Table */}
                      <div className="table-responsive shadow-sm rounded mb-4">
                        <table className="table table-bordered table-striped table-hover mb-0">
                          <thead style={{backgroundColor: '#f1f4f9'}}>
                            <tr>
                              <th style={{width: '20%', color: '#002147', fontWeight: 'bold'}}>Time</th>
                              <th style={{width: '60%', color: '#002147', fontWeight: 'bold'}}>Event / Session Details</th>
                              <th style={{width: '20%', color: '#002147', fontWeight: 'bold'}} className="text-center">Venue</th>
                            </tr>
                          </thead>
                          <tbody>
                            {daySchedule.events.map((event, eventIndex) => (
                              <tr key={eventIndex}>
                                <td style={{fontWeight: '600', color: '#444'}}>
                                  {event.time}
                                </td>
                                <td>
                                  <strong className="text-dark" style={{fontSize: '16px'}}>{event.title}</strong>
                                  {event.details && (
                                    <div className="text-muted mt-1 small" style={{whiteSpace: 'pre-line'}}>
                                      {event.details}
                                    </div>
                                  )}
                                </td>
                                <td className="text-center fw-medium text-secondary">
                                  {event.venue}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  ))}

                  {/* Footnote Alert */}
                  <div className="mt-5 pt-3 border-top">
                    <div className="alert alert-info">
                      <p className="mb-0 small">
                        <strong>Note:</strong> Schedule is subject to change. Detailed track breakdowns and abstract details will be provided at the registration desk in the RIEP Lobby.
                      </p>
                    </div>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Program;